export default {"src":"/_next/static/media/search.55c195a5.svg","height":26,"width":28,"blurWidth":0,"blurHeight":0};